import React, { createContext, useState, ReactNode } from 'react';

// Define the interface for the context value
interface PathContextProps {
  isPathMatched: boolean;
  isPathMatchedEditEmployee: boolean;
  setIsPathMatchedEditEmployee: (value: boolean) => void;
  setIsPathMatched: (value: boolean) => void;
  resetPathMatched: () => void;
}

// Define a default value for the context
const defaultContextValue: PathContextProps = {
  isPathMatched: false,
  isPathMatchedEditEmployee:false,
  setIsPathMatched: () => {}, // No-op function as default
  setIsPathMatchedEditEmployee: () => {},
  resetPathMatched: () => {}, // No-op function as default
};

// Create the context with the defined interface
export const PathContext = createContext<PathContextProps>(defaultContextValue);

// Define the Props for the Provider component
interface PathProviderProps {
  children: ReactNode;
}

// Create a provider component with types
export const PathProvider: React.FC<PathProviderProps> = ({ children }) => {
  // Global state to track if the path is matched
  const [isPathMatched, setIsPathMatched] = useState<boolean>(false);
  const [isPathMatchedEditEmployee, setIsPathMatchedEditEmployee] = useState<boolean>(false);
  // Function to reset the state to false
  const resetPathMatched = () => {
    setIsPathMatched(false) // Reset the state if the path doesn't match
    localStorage.removeItem("pathMatched") // Remove the item from localStorage
  };

  // Return the provider with the global state and the reset function
  return (
    <PathContext.Provider value={{ isPathMatched, setIsPathMatched, resetPathMatched,isPathMatchedEditEmployee, setIsPathMatchedEditEmployee }}>
      {children}
    </PathContext.Provider>
  );
};
